module.exports = __webpack_public_path__ + "static/media/queue18.81f38172.svg";